<div class="vip-checkbox-group">
  <div class="title-toggle-container">
    <div class="labels-container">
      <span class="vip-only-label">VIP only</span>
      <span class="subtitle-label">Select which VIP Level users will be able to buy this reward.</span>
    </div>
    <app-slide-toggle [checked]="isEnabled"
                      (checkedChange)="onToggleChange($event)"
                      [isBigToggle]="true"
                      class="toggle">
    </app-slide-toggle>
  </div>
  <mat-error *ngIf="control.invalid">
    {{ control.errors?.['minArrayLength']?.message }}
  </mat-error>

  <div style="display: flex; flex-flow: column;" *ngIf="isEnabled">
    <div *ngFor="let familyName of printerSeries" class="checkbox-groups">
      <div class="series-group">
        <h3>Series {{familyName}}</h3>
        <div class="checkbox-grid">
          <app-checkbox *ngFor="let item of getSeriesVIPBusinessLevels(familyName)"
                        [formGroup]="familiesForms[familyName]"
                        [abstractFormControlName]="item.id.toString()">
            {{ getVIPName(familyName, item.level) }}
          </app-checkbox>
        </div>
        <div *ngIf="getSeriesVIPBusinessLevels(familyName).length == 0">
            <span class="subtitle-label">This series has no VIP level</span>
          </div>
      </div>
    </div>
  </div>
</div>
